export const BASE_X_SMALL_SIZE = 440
export const BASE_SMALL_SIZE = 768
export const BASE_MEDIUM_SIZE = 1024
export const BASE_LARGE_SIZE = 1280
export const BASE_X_LARGE_SIZE = 1440

export default {
  BASE_X_SMALL_SIZE,
  BASE_SMALL_SIZE,
  BASE_MEDIUM_SIZE,
  BASE_LARGE_SIZE,
  BASE_X_LARGE_SIZE,
  X_SMALL: `${BASE_X_SMALL_SIZE}px`,
  SMALL: `${BASE_SMALL_SIZE}px`,
  MEDIUM: `${BASE_MEDIUM_SIZE}px`,
  LARGE: `${BASE_LARGE_SIZE}px`,
  X_LARGE: `${BASE_X_LARGE_SIZE}px`,
  xsmallScreen: (offset = 0) =>
    `@media (min-width: ${BASE_X_SMALL_SIZE + offset}px)`,
  smallScreen: (offset = 0) =>
    `@media (min-width: ${BASE_SMALL_SIZE + offset}px)`,
  mediumScreen: (offset = 0) =>
    `@media (min-width: ${BASE_MEDIUM_SIZE + offset}px)`,
  largeScreen: (offset = 0) =>
    `@media (min-width: ${BASE_LARGE_SIZE + offset}px)`,
  xlargeScreen: (offset = 0) =>
    `@media (min-width: ${BASE_X_LARGE_SIZE + offset}px)`,
}
